import { render, staticRenderFns } from "./UpdatePlateAndStatusSpecimen.vue?vue&type=template&id=68b50cc2"
import script from "./UpdatePlateAndStatusSpecimen.vue?vue&type=script&lang=js"
export * from "./UpdatePlateAndStatusSpecimen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports